import React from 'react';

import { MergeCheck } from 'src/types';
import {
  ForgeMergeCheckResult,
  ResultStatus,
} from 'src/types/custom-merge-checks';

import { StatusIcon } from './status-icon';
import { classicCheckAllowsMerge, customCheckResultAllowsMerge } from './utils';

export type OverallStatusIconProps = {
  isLoading: boolean;
  emptyResults?: boolean;
  preMergeCheckResults: ForgeMergeCheckResult[];
  classicMergeCheckResults: MergeCheck[];
};

export const OverallStatusIcon = ({
  isLoading,
  emptyResults,
  preMergeCheckResults,
  classicMergeCheckResults,
}: OverallStatusIconProps) => {
  let iconStatus: ResultStatus | null;
  if (isLoading || emptyResults) {
    iconStatus = null;
  } else if (
    preMergeCheckResults.every(result =>
      customCheckResultAllowsMerge(result)
    ) &&
    classicMergeCheckResults.every(classicCheckAllowsMerge)
  ) {
    iconStatus = 'SUCCESS';
  } else if (
    preMergeCheckResults.some(
      result =>
        result.status !== 'IN-PROGRESS' && !customCheckResultAllowsMerge(result)
    ) ||
    classicMergeCheckResults.some(check => !classicCheckAllowsMerge(check))
  ) {
    iconStatus = 'FAILED';
  } else {
    iconStatus = 'IN-PROGRESS';
  }

  return (
    <StatusIcon
      status={iconStatus}
      testIdPrefix="MergeChecksCardSecondaryIcon"
    />
  );
};
